import { SEPARATOR_CONTAINS_REGEX, SEPARATOR_SPLIT_PATTERN } from './constants.js';
const buildSplitRegex = (separators) => {
    const patterns = separators.map((separator) => SEPARATOR_SPLIT_PATTERN[separator]);
    return new RegExp(patterns.join('|'));
};
export const splitBySeparators = (text, separators) => {
    if (separators.length === 0) {
        return text.trim() ? [text.trim()] : [];
    }
    return text
        .split(buildSplitRegex(separators))
        .map((s) => s.trim())
        .filter(Boolean);
};
export const containsSeparator = (text, separators) => separators.some((separator) => SEPARATOR_CONTAINS_REGEX[separator].test(text));
